<template>
    <div v-if="guideline">
        <TheGuidelinesLayout>
            <template #sidebar>
                <BaseGuidelineChapters
                    v-if="(chapters && chapters.length) || pending"
                    :chapters="chapters ? chapters : null"
                    :numeric="false"
                    :pending="pending"
                />
            </template>

            <template v-if="!pending">
                <BaseStickyBar>
                    <BaseGuidelineChaptersSelect
                        v-if="(chapters && chapters.length) || pending"
                        :placeholder="`Select year`"
                        :chapters="chapters ? chapters : null"
                        :numeric="false"
                        :pending="pending"
                    />
                </BaseStickyBar>

                <NuxtPage
                    v-if="route?.params.year"
                    :page-key="`summary${route.params.year}`"
                    :guideline="guideline"
                    :summaries="summaries"
                />

                <TheGuidelinesPagesSummaryByYear
                    :summaries="summaries"
                    :guideline="guideline"
                />
            </template>

            <content-placeholders v-else>
                <content-placeholders-text :lines="5" />
                <content-placeholders-img />
                <content-placeholders-text :lines="1" />
                <br>
                <content-placeholders-text :lines="8" />
            </content-placeholders>
        </TheGuidelinesLayout>
    </div>
</template>

<script setup>
import SummaryOfChangesQuery from '~/graphql/queries/guidelines/summary-of-changes.graphql';

const props = defineProps({
    guideline: {
        required: true,
        type: Object,
        default: null
    }
});

const { activeSite } = useMultisite();
const { variables } = useCraftGraphql();

if (activeSite.value?.handle) {
    variables.site = activeSite.value?.handle;
}

if (props.guideline?.id) {
    variables.id = props.guideline.id;
}

delete variables.uri;

const response = await useLazyAsyncQuery({
    query: SummaryOfChangesQuery,
    variables
});

const {data, pending} = response;

const summaries = computed(() => {
    if (data?.value?.entry?.summariesOfChanges) {
        return data.value.entry.summariesOfChanges;
    }
    return null;
});

const chapters = computed(() => {
    if (props.guideline && summaries.value) {
        return summaries.value.map((summary) => {
            return {
                title: summary.changeYear,
                slug: summary.changeYear,
                uri: `guidelines/${props.guideline.slug}/summary-of-changes/${summary.changeYear}`
            };
        });
    }
    return null;
});
</script>
